var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 66,
    viewBox: "0 0 81 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3772_748)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8031 3.18177C12.3841 3.18177 11.2308 4.33662 11.2308 5.75755V62.8182H46.3703V5.75755C46.3703 4.33662 45.217 3.18177 43.798 3.18177H13.8031ZM8.05334 5.75755C8.05334 2.57938 10.6292 0 13.8031 0H43.798C46.9719 0 49.5477 2.57938 49.5477 5.75755V64.4091C49.5477 65.2877 48.8364 66 47.959 66H9.64206C8.76464 66 8.05334 65.2877 8.05334 64.4091V5.75755Z",
    fill: "#142784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0934 12.1417C47.5435 11.8481 48.1114 11.8022 48.6027 12.0197L72.0002 22.3764C72.5755 22.631 72.9466 23.2016 72.9466 23.8315V64.4091C72.9466 65.2877 72.2353 66 71.3579 66H47.9604C47.083 66 46.3717 65.2877 46.3717 64.4091V13.4748C46.3717 12.9368 46.6432 12.4353 47.0934 12.1417ZM49.5491 15.9174V62.8182H69.7692V24.8676L49.5491 15.9174Z",
    fill: "#142784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.4091C0 63.5305 0.711293 62.8182 1.58872 62.8182H79.4113C80.2887 62.8182 81 63.5305 81 64.4091C81 65.2877 80.2887 66 79.4113 66H1.58872C0.711293 66 0 65.2877 0 64.4091Z",
    fill: "#142784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7281 10.8715C14.7281 10.0197 15.4178 9.3291 16.2685 9.3291H41.1348C41.9855 9.3291 42.6751 10.0197 42.6751 10.8715V17.8888C42.6751 18.7406 41.9855 19.4312 41.1348 19.4312H16.2685C15.4178 19.4312 14.7281 18.7406 14.7281 17.8888V10.8715ZM17.8088 12.414V16.3463H39.5945V12.414H17.8088Z",
    fill: "#142784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7281 26.4723C14.7281 25.6204 15.4178 24.9299 16.2685 24.9299H41.1348C41.9855 24.9299 42.6751 25.6204 42.6751 26.4723V33.4896C42.6751 34.3414 41.9855 35.032 41.1348 35.032H16.2685C15.4178 35.032 14.7281 34.3414 14.7281 33.4896V26.4723ZM17.8088 28.0147V31.9471H39.5945V28.0147H17.8088Z",
    fill: "#142784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7281 42.0731C14.7281 41.2212 15.4178 40.5307 16.2685 40.5307H41.1348C41.9855 40.5307 42.6751 41.2212 42.6751 42.0731V49.0903C42.6751 49.9422 41.9855 50.6328 41.1348 50.6328H16.2685C15.4178 50.6328 14.7281 49.9422 14.7281 49.0903V42.0731ZM17.8088 43.6155V47.5479H39.5945V43.6155H17.8088Z",
    fill: "#142784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0767 26.5113C52.3783 25.6862 53.2907 25.2621 54.1147 25.5641L66.7739 30.2037C67.5978 30.5057 68.0213 31.4193 67.7198 32.2444C67.4182 33.0695 66.5057 33.4936 65.6818 33.1916L53.0226 28.552C52.1986 28.25 51.7751 27.3364 52.0767 26.5113Z",
    fill: "#142784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0767 35.0948C52.3783 34.2697 53.2907 33.8456 54.1147 34.1476L66.7739 38.7872C67.5978 39.0892 68.0213 40.0029 67.7198 40.828C67.4182 41.6531 66.5057 42.0771 65.6818 41.7751L53.0226 37.1355C52.1986 36.8336 51.7751 35.9199 52.0767 35.0948Z",
    fill: "#142784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0768 43.6768C52.3784 42.8517 53.2909 42.4277 54.1148 42.7298L66.774 47.3708C67.598 47.6729 68.0214 48.5866 67.7197 49.4117C67.418 50.2368 66.5056 50.6607 65.6816 50.3587L53.0224 45.7176C52.1985 45.4155 51.7751 44.5018 52.0768 43.6768Z",
    fill: "#142784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3772_748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad);
export default __webpack_public_path__ + "static/media/load.be3d1a44585b4540ac859806d29d32ce.svg";
export { ForwardRef as ReactComponent };